"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useRecommendationPlanTabs = require("../../../../hooks/recommendation/useRecommendationPlanTabs");
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _EntelPlanCard = _interopRequireDefault(require("./EntelPlanCard"));
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _constants = require("../../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BorderWrapper = _styledComponents.default.div`
  border: 1px solid #bebebe;
  border-radius: 12px;
`;
const TabWrapper = _styledComponents.default.div`
  padding: 20px 24px;
`;
const EntelPlansTab = _ref => {
  let {
    plans,
    selectedPlan
  } = _ref;
  const {
    onTabSwitch
  } = (0, _useRecommendationPlanTabs.useRecommendationPlanTabs)();
  const recommendationTabsCount = (0, _useConfig.default)('uiSettings.planRecommendationTabsCount', null);
  if (recommendationTabsCount && !isNaN(Number(recommendationTabsCount))) {
    plans = plans.slice(0, Number(recommendationTabsCount));
  }
  const market = (0, _useConfig.default)('market');
  return /*#__PURE__*/_react.default.createElement(BorderWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tabs, {
    tabs: {
      width: 'stretch'
    },
    onTabClick: onTabSwitch,
    externallySetTabId: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.productId,
    dataAttributes: {
      'data-test-id': 'tab'
    }
  }, plans.map((plan, index) => {
    var _TAP_TEXT_MAP$plan$ti;
    const tabText = market === _constants.MARKETS_MAP.cl ? (_TAP_TEXT_MAP$plan$ti = _constants.TAP_TEXT_MAP[plan.tier]) !== null && _TAP_TEXT_MAP$plan$ti !== void 0 ? _TAP_TEXT_MAP$plan$ti : plan.tier : plan.tier;
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tab, {
      key: plan.productId,
      text: _services.locale.localeString(`Recommendation.${tabText}`),
      id: plan.productId
    }, /*#__PURE__*/_react.default.createElement(TabWrapper, null, /*#__PURE__*/_react.default.createElement(_EntelPlanCard.default, {
      plan: plan,
      planIndex: index
    })));
  })));
};
var _default = EntelPlansTab;
exports.default = _default;